import { Layout } from '../../../../../components/Layout';
import { LastIntegrationTag } from '../LastIntegrationTag';
import styles from './NetworkPricesHeader.module.scss';

export const NetworkPricesHeader = () => (
  <Layout.Header className={styles.header}>
    <div className={styles.title}>
      <Layout.Title>Preços na rede</Layout.Title>
      <LastIntegrationTag />
    </div>
    <Layout.Subtitle>Gestão consolidada de preços na rede</Layout.Subtitle>
  </Layout.Header>
);
